import type { WebPushDiscoveryProps } from "./components/WebPushDiscovery";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyAction, type LazyComponent, LazyImport, LazyModule, } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "WebpushNotifications" */ "./lazyIndex"), { name: "WebpushNotifications" });

export const lazyBootstrapWebPushService: LazyAction<typeof lazyIndex.bootstrapWebPushService, typeof lazyModule> = new LazyAction(lazyModule, m => m.bootstrapWebPushService);

export const lazyUserInitiatedWebPushSetupWorkflow: LazyImport<typeof lazyIndex.userInitiatedWebPushSetupWorkflow, typeof lazyModule> = new LazyImport(lazyModule, m => m.userInitiatedWebPushSetupWorkflow);

export const lazyUserInitiatedWebPushDisableWorkflow: LazyImport<typeof lazyIndex.userInitiatedWebPushDisableWorkflow, typeof lazyModule> = new LazyImport(lazyModule, m => m.userInitiatedWebPushDisableWorkflow);

export const lazyUnsubscribeWebPushNotifications: LazyImport<typeof lazyIndex.unsubscribe, typeof lazyModule> = new LazyImport(lazyModule, m => m.unsubscribe);

export const lazyLoadWebPushOptions: LazyImport<typeof lazyIndex.loadWebPushOptions, typeof lazyModule> = new LazyImport(lazyModule, m => m.loadWebPushOptions);

export const WebPushDiscovery: LazyComponent<WebPushDiscoveryProps, unknown, void> = createLazyComponent(lazyModule, m => m.WebPushDiscovery);
